import { render, staticRenderFns } from "./OrbitSuccessStep.vue?vue&type=template&id=cfaedfe0&scoped=true"
import script from "./OrbitSuccessStep.vue?vue&type=script&lang=ts"
export * from "./OrbitSuccessStep.vue?vue&type=script&lang=ts"
import style0 from "./OrbitSuccessStep.vue?vue&type=style&index=0&id=cfaedfe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaedfe0",
  null
  
)

export default component.exports